import entity from '../../../models/mlm/receivables'

export default [
  {
    path: '/receivables',
    meta: {
      entity,
      requiresPermissionTo: 'receivables',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/receivables/new',
    meta: {
      entity,
      requiresPermissionTo: 'receivables',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/receivables/:id',
    meta: {
      entity,
      requiresPermissionTo: 'receivables',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
